import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PasswordManagerModule } from 'password-manager';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfileModule } from 'profile';
import { NotificationModule } from 'notification';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SubscriptionPlansModule } from 'subscription-plans';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TitleCasePipe, DatePipe } from '@angular/common';
import { HomeComponent } from './features/home/home.component';
import { SharedModule } from './shared/shared.module';
import { PasswordManagerComponent } from './core/password-manager/password-manager.component';
import { LoaderComponent } from './core/loader/loader.component';
import { BrowserModule } from '@angular/platform-browser';
import { LoginComponent } from './core/login/login.component';
import { ForgotPasswordComponent } from './core/login/forgot-password/forgot-password.component';
import { FlagService } from './core/global-layout/flag-service';
import { ConnectService } from './core/global-layout/language-service';
import { GlobalLayoutModule } from './core/global-layout/global-layout.module';
import { DashboardModule } from './features/dashboard/dashboard.module';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { AuthInterceptor } from './core/interceptors/auth-interceptor.service';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { DhhpAlertComponent } from './shared/dhhpalert/dhhpalert.component';
import { ProfileComponent } from './core/profile/profile.component';
import { FaqComponent } from './features/faq/faq.component';
import { SettingsComponent } from './features/settings/settings.component';
import { AdministrationComponent } from './features/administration/administration.component';
import { BulkActivationComponent } from './features/bulk-activation/bulk-activation.component';
import { BulkActivationModule } from './features/bulk-activation/bulk-activation.module';
import { AngularFireModule } from '@angular/fire';
import { environment } from 'src/environments/environment';
import {AngularFireAuthModule } from '@angular/fire/auth';
import { QrMainLayoutComponent } from './features/qr-main-layout/qr-main-layout.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    PasswordManagerComponent,
    HomeComponent,
    LoaderComponent,
    LoginComponent,
    ForgotPasswordComponent,
    DashboardComponent,
    DhhpAlertComponent,
    ProfileComponent,
    FaqComponent,
    SettingsComponent,
    AdministrationComponent,
    QrMainLayoutComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ProfileModule,
    NotificationModule,
    PasswordManagerModule,
    BrowserAnimationsModule, 
    SubscriptionPlansModule,
    HttpClientModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    GlobalLayoutModule,
    DashboardModule,
    BulkActivationModule,
    // AdministrationModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    }),
    PopoverModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase), 
    AngularFireAuthModule
  ],
  providers: [
    DhhpAlertComponent,
    ConnectService,
    FlagService,
    TitleCasePipe,
    DatePipe,
    {provide:HTTP_INTERCEPTORS,useClass:AuthInterceptor,multi:true},
    {provide:HTTP_INTERCEPTORS,useClass:LoaderInterceptor,multi:true}
  ],
  entryComponents:[],
  bootstrap: [AppComponent]
})
export class AppModule { }
